import React, { useContext, useEffect, useState } from "react";
import classes from "./MainFooter.module.css";
import { FaFacebookF, FaTwitter } from "react-icons/fa6";
import { FaLinkedinIn } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa6";
import { FaYoutube } from "react-icons/fa6";
import payments from '../../../assets/payments.png'
import FooterTopBg from '../../../assets/FooterTopBg.png'
import NorthIcon from '@mui/icons-material/North';
import data from '../../Data.json';
import { useDispatch, useSelector } from "react-redux";
import AuthContext from "../authContext";
import { Link, useLocation } from "react-router-dom";
import ServicesChar from "./ServicesChar/ServicesChar";
import whiteLogo from "../../../assets/whiteLogo.png";
import * as Scroll from "react-scroll";
import { addSelectedCategory, resetSearchData } from "../../redux/productSlice";
import { FaSnapchatGhost, FaTiktok } from "react-icons/fa";
import { buildFilterUrl } from "../../../utils/filterUrl";


// Helper function to slugify and sanitize text
const slugify = (text, placeholder = 'product') => {
  if (!text || text.trim() === '') return placeholder;
  const slug = text
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '') // Remove all symbols except spaces and hyphens
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/-+/g, '-') // Replace multiple hyphens with single hyphen
    .replace(/^-+|-+$/g, '');
  return slug || placeholder; // Remove leading/trailing hyphens
};

const MainFooter = () => {
  const language = useSelector((state) => state.products.selectedLanguage[0].Language);
  const dispatch = useDispatch();
    const path = useLocation().pathname;
  const authCtx = useContext(AuthContext)

  const scroller = Scroll.scroller;
  
    const NavigateAndScroll = (props) => {
      if (path === "/") {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      } else {
        setTimeout(() => {
          scroller.scrollTo(props, {
            duration: 500,
            delay: 0,
            smooth: true,
            offset: 50,
          });
        }, 400);
      }
    };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // Use smooth scrolling animation
    });
  };

  const slug = (text) => (text || "").toString().trim().replace(/\s+/g, "-").toLowerCase();

  const getCategoryHref = (id, parentName) =>
    buildFilterUrl(`/cp/${slug(parentName)}/${id}`, id ? { parentCategories: [id] } : {});

  // Side effects only — navigation now happens via the <Link to={...}> the
  // caller wraps this handler with, so the href is real and crawlable.
  const handleCategoryClick = (id) => {
    localStorage.removeItem("stock");
    localStorage.removeItem("categories");
    localStorage.removeItem("collections");
    localStorage.removeItem("multiproductids");
    localStorage.removeItem("publishers");
    localStorage.removeItem("subCategories");
    localStorage.removeItem("subSubCategories");
    localStorage.removeItem("parentCategories");
    localStorage.removeItem("min_price");
    localStorage.removeItem("max_price");
    dispatch(resetSearchData());
    dispatch(addSelectedCategory(id === null ? null : String(id)));
    if (id) localStorage.setItem("parentCategories", JSON.stringify([id]));
  };
  return (
      <div className={classes.footer} >
        <div className={classes.newsletter_con}>
        <ServicesChar />
        </div>
        <div className={classes.content}>
        <img src={FooterTopBg} alt="" className={classes.topBg}/>
          <div className={classes.top_con} onClick={()=>console.log(authCtx?.companySettings)}>
          </div>
          <div className={classes.middle_con}>
            <div className={classes.column} style={{display:"flex",flexDirection:"row",height:"fit-content",marginTop:"0"}}>
            <Link to="/" onClick={NavigateAndScroll}>
              <img src={whiteLogo} alt="Logo" className={classes.logo} style={{cursor:"pointer"}}/>
            </Link>
            <div className={classes.column}>
            <h2 style={{fontSize:"calc(.8rem + 0.3vw)"}}>{data.Footer.WhoWeAre.title[language]} ?</h2>
              <p style={{color:'#fff',cursor:"auto"}} dangerouslySetInnerHTML={{ __html: language === 'eng' ? authCtx?.companySettings.about_en : authCtx?.companySettings.about_fr }} />
            </div>
            
            </div>
            <div  className={classes.column}>
              <h2 onClick={()=>console.log(authCtx?.articleFamilleParents)}>{language === "eng" ? 'Categories' : "Catégories"}</h2>
            {authCtx?.articleFamilleParents?.map((item)=>(
              <Link key={item?.id} to={getCategoryHref(item?.id, item?.nom)} onClick={() => handleCategoryClick(item?.id)} className={classes.footerLink}>{item?.nom}</Link>
            ))}
            </div>
            <div  className={classes.column}>
              <h2 >{data.Footer.NeedHelp.title[language]} ?</h2>
              <Link to="/about-us" className={classes.footerLink}>{language === 'eng' ? "About Us" : "A Propos"}</Link>
              <Link to="/blogs" className={classes.footerLink}>{language === 'eng' ? "Blogs" : "Blogs"}</Link>
              <Link to="/events" className={classes.footerLink}>{language === 'eng' ? "Events" : "Événements"} </Link>
              <Link to="/contactus" className={classes.footerLink}>Contact</Link>
              <Link to="/cgv" className={classes.footerLink}>{language === "eng" ? "Terms & Conditions" : "CGV"}</Link>
              <Link to="/mentions-legales" className={classes.footerLink}>{language === 'eng' ? "Legal Notice" : "Mentions légales"}</Link>
              <Link to="/politique-de-confidentialite" className={classes.footerLink}>{language === 'eng' ? "Privacy Policy" : "Politique de confidentialité"}</Link>
              <Link to="/livraison" className={classes.footerLink}>{language === 'eng' ? "Shipping" : "Livraison"}</Link>
              <Link to="/retours-remboursements" className={classes.footerLink}>{language === 'eng' ? "Returns & Refunds" : "Retours & Remboursements"}</Link>
            </div>
            <div  className={classes.column}>
            <h2 >{data.Footer.Service.title[language]}</h2>
            <p style={{color:'#fff',cursor:"auto",fontWeight:"600",fontSize:"calc(0.7rem + 0.3vw)",margin:'.7em 0 0 0'}}>Email</p>
            <a
              href={`mailto:${authCtx?.companySettings?.email}`}
              style={{ color: '#fff', cursor: 'pointer', marginTop: '0', textDecoration: 'none' }}
              aria-label={`Email ${authCtx?.companySettings?.email}`}
            >
              {authCtx?.companySettings?.email}
            </a>
            <p style={{color:'#fff',cursor:"auto",fontWeight:"600",fontSize:"calc(0.7rem + 0.3vw)",margin:'.7em 0 0 0'}}>{language === "eng" ? "Phone" : "Téléphone"}</p>
            <a
              href={`tel:${authCtx?.companySettings?.phone}`}
              style={{ color: '#fff', cursor: 'pointer', marginTop: '0', textDecoration: 'none' }}
              aria-label={`Phone ${authCtx?.companySettings?.phone}`}
            >
              {authCtx?.companySettings?.phone}
            </a>
            </div>
          </div>
          
          <div className={classes.middle_con_mobile}>
            <div className={classes.column}>
            <img src={whiteLogo} alt="Logo" className={classes.logo}/>
            <h2 style={{fontSize:"calc(.8rem + 0.3vw)"}}>{data.Footer.WhoWeAre.title[language]} ?</h2>
              <p style={{color:'#fff',cursor:"auto"}} dangerouslySetInnerHTML={{ __html: language === 'eng' ? authCtx?.companySettings.about_en : authCtx?.companySettings.about_fr }} />
            </div>
            <div  className={classes.column}>
              <h2 >{language === "eng" ? 'Categories' : "Catégories"}</h2>
            {authCtx?.articleFamilleParents?.map((item)=>(
              <Link key={item?.id} to={getCategoryHref(item?.id, item?.nom)} onClick={() => handleCategoryClick(item?.id)} className={classes.footerLink}>{item?.type_nom}</Link>
            ))}
            </div>
            <div  className={classes.column}>
              <h2 >{data.Footer.NeedHelp.title[language]} ?</h2>
              <Link to="/about-us" className={classes.footerLink}>{language === 'eng' ? "About Us" : "A Propos"}</Link>
              <Link to="/blogs" className={classes.footerLink}>{language === 'eng' ? "Blogs" : "Blogs"}</Link>
              <Link to="/events" className={classes.footerLink}>{language === 'eng' ? "Events" : "Événements"} </Link>
              <Link to="/contactus" className={classes.footerLink}>Contact</Link>
              <Link to="/cgv" className={classes.footerLink}>{language === "eng" ? "Terms & Conditions" : "CGV"}</Link>
              <Link to="/mentions-legales" className={classes.footerLink}>{language === 'eng' ? "Legal Notice" : "Mentions légales"}</Link>
              <Link to="/politique-de-confidentialite" className={classes.footerLink}>{language === 'eng' ? "Privacy Policy" : "Politique de confidentialité"}</Link>
              <Link to="/livraison" className={classes.footerLink}>{language === 'eng' ? "Shipping" : "Livraison"}</Link>
              <Link to="/retours-remboursements" className={classes.footerLink}>{language === 'eng' ? "Returns & Refunds" : "Retours & Remboursements"}</Link>
            </div>
            <div  className={classes.column}>
            <h2 >{data.Footer.Service.title[language]}</h2>
            <p style={{color:'#fff',cursor:"auto",fontWeight:"600",fontSize:"calc(0.7rem + 0.3vw)",margin:'.7em 0 0 0'}}>Email</p>
            <a
              href={`mailto:${authCtx?.companySettings?.email}`}
              style={{ color: '#fff', cursor: 'pointer', marginTop: '0', textDecoration: 'none' }}
              aria-label={`Email ${authCtx?.companySettings?.email}`}
            >
              {authCtx?.companySettings?.email}
            </a>
            <p style={{color:'#fff',cursor:"auto",fontWeight:"600",fontSize:"calc(0.7rem + 0.3vw)",margin:'.7em 0 0 0'}}>{language === "eng" ? "Phone" : "Téléphone"}</p>
            <a
              href={`tel:${authCtx?.companySettings?.phone}`}
              style={{ color: '#fff', cursor: 'pointer', marginTop: '0', textDecoration: 'none' }}
              aria-label={`Phone ${authCtx?.companySettings?.phone}`}
            >
              {authCtx?.companySettings?.phone}
            </a>
            </div>
          </div>
          <div className={classes.bottom_con}>
            <p style={{marginBottom:'0.3em'}}>{language === 'eng' ? "Follow Us" : "Suivez-nous"} !</p>
            <div className={classes.iconsContainer}>
              {authCtx?.companySettings?.facebook && <a
                href={authCtx?.companySettings.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className={classes.socialsIcon}
              >
                <FaFacebookF className={classes.icon}/>
              </a>}
              {authCtx?.companySettings?.insta && <a
                href={authCtx?.companySettings.insta}
                target="_blank"
                rel="noopener noreferrer"
                className={classes.socialsIcon}
                >
                <FaInstagram className={classes.icon}/>
              </a>}
              {authCtx?.companySettings?.youtube && <a
                href={authCtx?.companySettings.youtube}
                target="_blank"
                rel="noopener noreferrer"
                className={classes.socialsIcon}
                >
                <FaYoutube className={classes.icon}/>
              </a>}
              {authCtx?.companySettings?.twitter && <a
                href={authCtx?.companySettings.twitter}
                target="_blank"
                rel="noopener noreferrer"
                className={classes.socialsIcon}
                >
                <FaTwitter className={classes.icon}/>
              </a>}
              {authCtx?.companySettings?.linkedin && <a
                href={authCtx?.companySettings.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className={classes.socialsIcon}
                >
                <FaLinkedinIn className={classes.icon}/>
              </a>}
              {authCtx?.companySettings?.tiktok && <a
                href={authCtx?.companySettings.tiktok}
                target="_blank"
                rel="noopener noreferrer"
                className={classes.socialsIcon}
                >
                <FaTiktok className={classes.icon}/>
              </a>}
              {authCtx?.companySettings?.snapchat && <a
                href={authCtx?.companySettings.snapchat}
                target="_blank"
                rel="noopener noreferrer"
                className={classes.socialsIcon}
                >
                <FaSnapchatGhost className={classes.icon}/>
              </a>}
            </div>
          </div>
      <div className={classes.copyRight}>
        <p  className={classes.copy_p}>
           {language === 'eng' ? authCtx?.companySettings.copyrights_en : authCtx?.companySettings.copyrights_fr } 
        </p>
          <div className={classes.footer_bottom_con}>
          <div className={classes.payments_con}>
            <img src={payments} alt="" />
    <div onClick={scrollToTop} className={classes.scroll}>
      <NorthIcon  style={{margin:'auto', width:'90%', height:'70%'}}/>
    </div>
          </div>
          </div>
      </div>
        </div>
      </div>
  );
};

export default MainFooter;
